/**
 * @generated SignedSource<<5efd4a44b24bb87c092d4fc494599337>>
 * @relayHash ee5a91706bc8d2c36266138f1556fa8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a

import type { ConcreteRequest } from 'relay-runtime';
export type GlobalNavigationComponentQuery$variables = {
  entityAri: string;
  ownerAri: string;
};
export type GlobalNavigationComponentQuery$data = {
  readonly settings_navigationCustomisation: {
    readonly id: string;
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null;
        readonly visible: boolean | null;
      } | null> | null;
    } | null;
  } | null;
};
export type GlobalNavigationComponentQuery = {
  response: GlobalNavigationComponentQuery$data;
  variables: GlobalNavigationComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "entityAri",
        "variableName": "entityAri"
      },
      {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
      }
    ],
    "concreteType": "SettingsNavigationCustomisation",
    "kind": "LinkedField",
    "name": "settings_navigationCustomisation",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SettingsMenuItemConnection",
        "kind": "LinkedField",
        "name": "sidebar",
        "plural": false,
        "selections": [
          {
            "concreteType": "SettingsMenuItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "menuId"
              },
              {
                "kind": "ScalarField",
                "name": "visible"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalNavigationComponentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalNavigationComponentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ee5a91706bc8d2c36266138f1556fa8e",
    "id": "7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a",
    "metadata": {},
    "name": "GlobalNavigationComponentQuery",
    "operationKind": "query",
    "text": "query GlobalNavigationComponentQuery($entityAri:ID!,$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri,ownerAri:$ownerAri){id,sidebar{nodes{menuId,visible}}}}"
  }
};
})();

(node as any).hash = "0e74e77d53a00c9095e60ae7930a7cf3";

export default node;
